
//Components
import AContact from "../components/AContact.js"
import Contact from "../components/Contact.js"
import Dev from "../components/Dev.js"
import Navbar from "../components/Navbar.js"

export default function Contacto () {
    return (
        <div>
            <AContact />
            <Navbar />
            <Contact />
            <Dev />
        </div>
    )
}